<template>
    <div>
        <div class="card card-custom gutter-b">
            <div class="card-header d-flex justify-content-between">
                <div class="card-title">
                    <h3 class="card-label">Quản lý vùng</h3>
                </div>
                <div class="card-title">
                    <el-button class="btn-success btn" @click="showCreate">Thêm mới</el-button>
                </div>
            </div>
            <div class="card-body">
                <!--begin::Example-->
                <div class="row">
                    <div class="col-md-3">
                        <label>Tên vùng</label>
                        <div class="form-group">
                            <el-input placeholder="Tìm tên, ID vùng" v-model="query.keyword"></el-input>
                        </div>
                        <!--end::Form-->
                    </div>
                    <div class="col-md-2 mt-8">
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-primary font-weight-bold mr-2"
                                    :class="{'spinner spinner-white spinner-left': is_disable_search}"
                                    @click="searchData">
                                <i class="fa fa-search"></i> Tìm kiếm
                            </button>
                        </div>
                    </div>
                </div>

                <div class="example mb-10">
                    <div class="example-preview table-responsive leaderboard">
                        <table class="table table-vertical-center">
                            <thead class="thead-light">
                            <tr>
                                <th>ID vùng</th>
                                <th>Tên vùng</th>
                                <th>Khu vực</th>
                                <th>Văn phòng đầu tiên</th>
                                <th>Hành động</th>
                            </tr>
                            </thead>
                            <tbody v-if="region.length === 0">
                            <tr>
                                <td colspan="5" class="text-center">
                                    Không có dữ liệu.
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr
                                v-for="(item, index) in region"
                                :key="index"
                            >
                                <td>{{ item.id }}</td>
                                <td>{{ item.name }}</td>
                                <td>
                                    <span v-for="(i, u) in item.areas">{{ i.name }}<span
                                        v-if="item.areas.length - u != 1">, </span></span>
                                </td>
                                <td>
                                    <span v-for="(i, u) in item.areas">
                                        {{ i.branch_first ? (i.branch_first.name_alias ?? i.branch_first.name) : '' }}
                                        <span v-if="item.areas.length - u != 1">, </span>
                                    </span>
                                </td>
                                <td>
                                    <button class="el-icon-edit p-2 border border-warning text-warning mx-1 rounded"
                                            data-toggle="tooltip"
                                            title="Sửa khu vực"
                                            @click="editRegion(item)"
                                    >
                                    </button>
                                    <button class="el-icon-delete p-2 border border-danger text-danger mx-1 rounded"
                                            data-toggle="tooltip"
                                            title="Xoá khu vực"
                                            @click="showDelete(item)"
                                    >
                                    </button>
                                    <button class="el-icon-alarm-clock p-2 border-violet text-violet mx-1 rounded"
                                            data-toggle="tooltip"
                                            title="Lịch sử"
                                            @click="getHistory(item.id)"
                                    >
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="mb-0 d-flex flex-row-reverse mr-10">
                    <p class="mb-0">Tổng số bản ghi: <span class="text-primary ">{{ total }}</span></p>
                </div>
            </div>
            <div class="edu-paginate mx-auto text-center">
                <paginate
                    v-model="page"
                    :page-count="last_page"
                    :page-range="3"
                    :margin-pages="1"
                    :click-handler="clickCallback"
                    :prev-text="'Trước'"
                    :next-text="'Sau'"
                    :container-class="'pagination b-pagination'"
                    :pageLinkClass="'page-link'"
                    :next-link-class="'next-link-item'"
                    :prev-link-class="'prev-link-item'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :page-class="'page-item'"
                >
                </paginate>
            </div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogCreate">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                <form class="form" id="area_create" @submit.prevent="handleSubmit(onSubmit)">
                    <div class="d-flex">
                        <div class="col-md-6">
                            <ValidationProvider vid="name" name="Tên vùng" rules="required"
                                                v-slot="{ errors,classes }">
                                <label for="">Tên vùng <span class="text-danger">*</span></label>
                                <input maxlength="100" type="text" v-model="formDataCreate.name" class="form-control">
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6">
                            <label for="">Khu vực <span class="text-danger">*</span></label>
                            <ValidationProvider vid="area" name="Khu vực" rules="required"
                                                v-slot="{ errors,classes }">
                                <el-select v-model="formDataCreate.areaIds"
                                           class="w-100"
                                           placeholder="Loại khu vực"
                                           clearable
                                           collapse-tags
                                           multiple
                                           filterable
                                >
                                    <el-option
                                        v-for="item in areas"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <span slot="footer" class="dialog-footer d-flex justify-content-end mt-3">
                        <button class="btn btn-secondary mr-2" @click="cancelDialog()">Hủy</button>
                        <button  class="btn btn-info" :disabled="loading" v-loading="loading">
                            <p class="mb-0" >
                              Xác nhận
                            </p>
                        </button>
                    </span>
                </form>
            </ValidationObserver>
        </el-dialog>
        <el-dialog title="Lịch sử" :visible.sync="dialogHistory">
            <div class="example-preview table-responsive leaderboard">
                <table class="table table-vertical-center">
                    <thead class="thead-light">
                        <tr>
                            <th>Tháng</th>
                            <th>Khu vực</th>
                            <th>Văn phòng đầu tiên</th>
                        </tr>
                    </thead>
                    <tbody
                        v-for="(item, index) in dataHistory"
                        :key="index"
                    >
                        <td>{{ item.month + '/' + item.year }} </td>
                        <td>
                           <span v-for="(i, u) in item.region.areas">
                                {{ i.name }}
                                <span v-if="item.region.areas.length - u != 1">, </span>
                            </span>
                        </td>
                        <td>
                            <span v-for="(i, u) in item.region.areas">
                                {{ i.branch_first ? (i.branch_first.name_alias ?? i.branch_first.name) : '' }}
                                <span v-if="item.region.areas.length - u != 1">, </span>
                            </span>
                        </td>
                    </tbody>
                </table>
            </div>
        </el-dialog>
        <el-dialog title="Xoá vùng" :visible.sync="dialogConfirm" width="30%">
            <div>
                <span >
                    Bạn có chắc chắn muốn xóa vùng <span style="font-weight: bold">{{ textAreaDelete }}</span> không?
                </span>
            </div>
            <span slot="footer" class="dialog-footer d-flex justify-content-end mt-3">
                <button class="btn btn-secondary mr-2" @click="dialogConfirm = false">Hủy</button>
                <button @click="deleteRegion" class="btn btn-info" :disabled="loading" v-loading="loading">
                    <p class="mb-0" >
                      Xác nhận
                    </p>
                </button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    CREATE_REGION,
    DELETE_REGION,
    GET_REGION, HISTORY_REGION,
    UPDATE_REGION
} from "@/core/services/store/center/region.module";
import {GET_LIST_AREAS} from "@/core/services/store/center/area.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
    name: "RegionIndex",
    data() {
        return {
            query: {
                keyword: '',
            },
            is_disable_search: '',
            region: [],
            page: 1,
            last_page: 1,
            total: 0,
            dialogCreate: false,
            formDataCreate: {
                id: '',
                name: '',
                areaIds: []
            },
            areas: [],
            loading: false,
            title: 'Thêm mới',
            is_update: false,
            dataHistory: [],
            dialogHistory: false,
            disableCreate: false,
            dialogConfirm: false,
            textAreaDelete: '',
            idDelete: ''
        }
    },
    mounted() {
        this.getData();
        this.getArea();
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý vùng"},
            {title: "Danh sách vùng"}
        ]);
    },
    methods: {
        getData() {
            this.$store.dispatch(GET_REGION, {paginate: true, page: this.page, keyword: this.query.keyword }).then((res) =>
            {
                this.region = res.data.data;
                this.last_page = res.data.last_page;
                this.page = res.data.current_page;
                this.total = res.data.total;
            }).catch((e) => {
                if (e.data.data.message_validate_form) {
                    this.$refs.form.setErrors(e.data.data.message_validate_form);
                }
            });
        },
        searchData() {
            this.getData();
        },
        clickCallback(obj) {
            this.page = obj
            this.$router.push({path: '/region', query: {page: this.page}})
            this.getData()
        },
        showCreate()
        {
            this.title = 'Thêm mới'
            this.dialogCreate = true;
            this.is_update = false;
            this.formDataCreate = {
                id: '',
                name: '',
                areaIds: []
            }
        },
        onSubmit()
        {
            this.loading = true;
            if (this.is_update)
            {
                this.$store.dispatch(UPDATE_REGION, this.formDataCreate).then(data => {
                    this.$notify({
                        title: 'Thành công',
                        message: 'Cập nhật vùng thành công !',
                        type: 'success'
                    });
                    this.loading = false;
                    this.cancelDialog();
                    this.getData();
                });

                return;
            }
            this.$store.dispatch(CREATE_REGION, this.formDataCreate).then(data => {
                this.noticeMessage(data.message)
                this.$notify({
                    title: 'Thành công',
                    message: 'Tạo vùng thành công !',
                    type: 'success'
                });
                this.loading = false;
                this.getData();
                this.cancelDialog();
            });
        },
        getArea()
        {
            this.$store.dispatch(GET_LIST_AREAS, {}).then(data => {
                this.areas = data.data;
            });
        },
        cancelDialog()
        {
            this.dialogCreate = false;
            this.formDataCreate.id = '';
            this.formDataCreate.name = '';
            this.formDataCreate.areaIds = [];
        },
        editRegion(item)
        {
            this.title = 'Sửa vùng';
            this.dialogCreate = true;
            const areaIds = item.areas.map(item => { return item.id });
            this.formDataCreate.id = item.id;
            this.formDataCreate.name = item.name;
            this.formDataCreate.areaIds = areaIds;
            this.is_update = true;
        },
        showDelete(item)
        {
            this.dialogConfirm = true;
            this.textAreaDelete = item.slug;
            this.idDelete = item.id;
        },
        deleteRegion()
        {
            this.$store.dispatch(DELETE_REGION, this.idDelete).then(data => {
                if (data.message)
                {
                    this.$notify({
                        title: 'Thất bại',
                        message: data.message,
                        type: 'warning'
                    });
                    this.dialogConfirm = false;
                    return;
                }
                this.$notify({
                    title: 'Thành công',
                    message: 'Xoá vùng thành công !',
                    type: 'success'
                });
                this.dialogConfirm = false;

                this.getData();
            }).catch((e) => {
                this.$notify({
                    title: 'Thất bại',
                    message: 'Không thể xoá vùng khi có khu vực đi cùng !',
                    type: 'warning'
                });
                this.dialogConfirm = false;
            });
        },
        getHistory(id)
        {
            this.dataHistory = [];
            this.dialogHistory = true;
            this.$store.dispatch(HISTORY_REGION, {id: id}).then(data => {
                this.dataHistory = data.data;
            });
        }
    }
}
</script>

<style scoped>
    .border-violet {
        border: 1px solid #5E00B6;
    }
    .text-violet {
        color: #5E00B6;
    }
</style>